import React, { FC, useState } from 'react'
import clsx from 'clsx'

import { IconClock } from '../../../../icons/IconClock'
import { HorseTrainer } from '../../../../rider/HorseTrainer/HorseTrainer'

import { getIconColor } from '../../../../../helpers/getIconColor'
import { getRideTime } from '../../../../../helpers/time'

import {
  IEventTeamMemberInterface,
  useEventRiderTeamMembers,
} from '../../../../../hooks/useEventRiderTeamMembers'

import { IBreak } from '../../../../../models/events/event.interface'
import { IHorseData } from '../../../../../models/horse/horse.interface'
import { IRegistrationByDayInterface } from '../../../../../models/registrations-by-day/registrationByDay.interface'
import { RegistrationFeesType } from '../../../../../models/event-fees/event-fees.interface'

import { sortByOrder } from '../../../../../pages/organizer/manage/ManageClinicNOtherOperationsTab/data/operations-tab-utils'
import { getRidersByRideTimeByClass } from '../../../../../pages/organizer/manage/ManageClinicNOtherOperationsTab/components/OrderOfGoTable/data/order-of-go-rider-utils'

import Clock from 'web/public/assets/cp_icons/Clock-1.svg'

import { IMAGE_CONSTS } from '../../../../../const/image-const'
import { HORSE_NAME_DEFAULT } from '../../../../../models/registrations-by-day/registrationByDay.interface'

// Types
type ExhibitorOrderOfGoAccordionProps = {
  data: any
  increment?: string
  isPublishOrder: boolean
  horses: IHorseData[]
  eventId: string
  isRiderMode?: boolean
  flattenedFees: RegistrationFeesType[]
}

interface DetailRowProps {
  increment?: string
  color: string
  row: IRegistrationByDayInterface | IBreak
  isPublishOrder: boolean
  horse?: IHorseData
  eventTeamMembers: IEventTeamMemberInterface
  eventTeamMembersLoading: boolean
  isRiderMode?: boolean
  isLast?: boolean
  data: any
  flattenedFees: RegistrationFeesType[]
}

const DetailRow: FC<DetailRowProps> = ({
  row,
  increment,
  isPublishOrder,
  color,
  eventTeamMembers,
  eventTeamMembersLoading,
  isLast,
  isRiderMode,
  data,
  flattenedFees,
}) => {
  const [errorImg, setErrorImg] = useState(false)
  if ((row as IBreak).isBreakDrag) {
    if (!isPublishOrder) {
      return <></>
    }
    function convertTimeStringToReadableFormat(timeString: string): string {
      const [hoursStr, minutesStr, secondsStr] = timeString.split(':')

      const hours = parseInt(hoursStr, 10)
      const minutes = parseInt(minutesStr, 10)
      const seconds = parseInt(secondsStr, 10)

      let result = ''

      if (hours > 0) {
        result += `${hours}h `
      }

      if (minutes > 0) {
        result += `${minutes}min `
      }

      if (seconds > 0) {
        result += `${seconds}sec`
      }

      return result.trim()
    }
    return (
      <>
        <div className={'flex w-full my-4 justify-between gap-4'}>
          <div className={'flex-1'}>
            <div className={'flex items-center gap-3'}>
              <span
                className={
                  'w-[45px] h-[45px] rounded-full flex items-center justify-center bg-[#F6F7FB]'
                }
              >
                <IconClock />
              </span>

              <span className={'text-SeabiscuitDark200ThemeColor font-bold text-base'}>
                Break / Drag
              </span>
            </div>
          </div>
          <div>
            <div className="md:ml-auto flex gap-3 justify-center items-center">
              <div>
                <div className="font-semibold text-right">Break</div>
                <div className="opacity-50 flex items-center gap-1 text-[14px]">
                  <img src={Clock} className="w-4" alt="" />
                  {convertTimeStringToReadableFormat((row as IBreak).time) || '0min'}
                </div>
              </div>
              <div className="p-1 rounded-full w-[45px] h-[45px] flex items-center justify-center bg-[#F6F7FB] text-black">
                {(row as IBreak).order}
              </div>
            </div>
          </div>
        </div>
        {!isLast && <hr />}
      </>
    )
  }
  const registration = row as IRegistrationByDayInterface

  const arrayName = registration.riderName?.split(' ') || []

  const matchingFee = flattenedFees?.find(
    (feeItem: RegistrationFeesType) => feeItem.uuid === (row as IRegistrationByDayInterface)?.uuid
  )

  let rideTime = 'Not Set'
  if (isRiderMode && registration.rideTime) {
    rideTime = getRideTime(registration.rideTime)
  } else if (matchingFee && increment) {
    const ridersByRideTimeByClass = getRidersByRideTimeByClass(data, matchingFee, increment)
    const current = ridersByRideTimeByClass.find((item) => item.id === row.id)
    rideTime = current?.rideTimeScheduleByClass || 'Not Set'
  }

  return (
    <>
      <div className="flex flex-wrap items-center justify-between w-full my-1 gap-4 md:gap-2">
        <div className="w-full md:w-1/3 flex items-center">
          {registration.riderProfilePicture && !errorImg ? (
            <img
              onError={() => setErrorImg(true)}
              src={registration.riderProfilePicture}
              alt="avatar"
              className="w-[45px] h-[45px] rounded-full mt-1 object-cover"
            />
          ) : (
            <div
              style={{ background: color }}
              className={`w-[45px] h-[45px] rounded-full mt-1 flex items-center justify-center text-white`}
            >
              {arrayName[0][0]}
              {arrayName.length > 1 ? arrayName[arrayName.length - 1][0] : ''}
            </div>
          )}
          <div className="ml-3">
            <div className="text-SeabiscuitDark200ThemeColor text-base">
              {registration.riderName}
            </div>
            <span className="text-SeabiscuitDark200ThemeColor/50 text-sm">
              {registration.backNumber ? `Back number • ${registration.backNumber}` : null}
            </span>
          </div>
        </div>
        <div className="w-full md:w-1/3 flex items-center">
          <img
            src={
              registration?.horseProfilePicture
                ? registration.horseProfilePicture
                : IMAGE_CONSTS.PLACEHOLDERS.USER
            }
            alt="avatar"
            className="w-[45px] h-[45px] rounded-full mt-1 object-cover"
          />
          <div className="ml-3">
            <div className="text-SeabiscuitDark200ThemeColor text-base">
              {registration.horseName ?? HORSE_NAME_DEFAULT}
            </div>
            <span className="text-base text-SeabiscuitDark200ThemeColor/50">
              <HorseTrainer
                title="Trainer"
                eventTeamMembers={eventTeamMembers}
                eventTeamMembersLoading={eventTeamMembersLoading}
                rider={registration}
              />
            </span>
          </div>
        </div>
        {isPublishOrder ? (
          <div className="md:ml-auto flex gap-3 justify-center items-center">
            <div>
              <div className="font-semibold text-sm text-right">
                {isRiderMode ? 'Ride Time' : 'Place'}
              </div>
              <div
                className={clsx('flex items-center gap-1 text-[14px]', {
                  'line-through text-SeabiscuitDark200ThemeColor/50 ': isRiderMode
                    ? registration.isScratched // isScratched for rider mode
                    : registration.orderOfGoScratched, // orderOfGoScratched for class mode for now, will change
                })}
              >
                <img src={Clock} className="w-4" alt="" />
                {rideTime}
              </div>
            </div>
            <div className="p-1 rounded-full w-[45px] h-[45px] flex items-center justify-center bg-[#F6F7FB] text-black">
              {registration.isOutOfTurn ? 'OT' : registration.order}
            </div>
          </div>
        ) : (
          <div className="md:ml-auto">
            <div className="md:text-right text-SeabiscuitDark200ThemeColor">Order of Go</div>
            <div className="md:text-right text-[14px] text-SeabiscuitDark200ThemeColor/50">
              Not yet published
            </div>
          </div>
        )}
      </div>
      {!isLast && <hr />}
    </>
  )
}

const ExhibitorOrderOfGoAccordion: FC<ExhibitorOrderOfGoAccordionProps> = ({
  data,
  increment,
  isPublishOrder,
  horses,
  eventId,
  isRiderMode,
  flattenedFees,
}) => {
  const { eventTeamMembers, eventTeamMembersLoading } = useEventRiderTeamMembers(eventId)

  return (
    <>
      {data?.length > 0 &&
        (isRiderMode ? data : sortByOrder(data)).map(
          (currentItem: IRegistrationByDayInterface | IBreak, index: number) => {
            const isLast = data.length - 1 === index
            const regByDay = currentItem as IRegistrationByDayInterface

            return (
              <DetailRow
                key={index}
                row={currentItem}
                eventTeamMembers={eventTeamMembers}
                eventTeamMembersLoading={eventTeamMembersLoading}
                increment={increment}
                isPublishOrder={isPublishOrder}
                horse={
                  (currentItem as IBreak).isBreakDrag
                    ? undefined
                    : horses.find((horse) => horse.id === regByDay.horseId)
                }
                isLast={isLast}
                color={getIconColor(data?.length, index)}
                isRiderMode={isRiderMode}
                data={data}
                flattenedFees={flattenedFees}
              />
            )
          }
        )}
    </>
  )
}

export default ExhibitorOrderOfGoAccordion
